export class User {
  public id: number;
  public name: string;
  public email: string;
  public password: string;
  public token: string;

  constructor() { }
}
